import { Button, Form, Radio, Tooltip, Typography } from 'antd'
import withSort from 'elements/HOC/withSort'
import CustomSelect from 'elements/Select/CustomSelect'
import withData from 'elements/Select/withData'
import { get } from 'lodash'
import { rules } from 'modules/FormItems'
import React from 'react'
import { compose } from 'recompose'
import CustomSpin from '../../../elements/CustomSpin'

const { Paragraph, Title } = Typography

const Question = ({ question, description, options, value, getFieldDecorator, path, fetch }) => {
  const Select = compose(withData({ data: options, fetch }), withSort)(CustomSelect)

  return (
    <div className="p-5">
      <Title level={4}>{question}</Title>
      <Paragraph>{description}</Paragraph>
      {getFieldDecorator(path, {
        initialValue: value,
        rules: rules.select,
      })(<Select />)}
    </div>
  )
}

function QuestionnaireSystemForm(props) {
  const { template, fetching, submit, data, submitting, isNew, update, fetch } = props

  const results = data?.results || []
  const { questions } = template
  const { getFieldDecorator } = props.form

  return (
    <CustomSpin spinning={fetching}>
      <Form>
        {questions?.map((i) => (
          <Question {...{ ...i, getFieldDecorator, value: results?.[i.path], fetch }} />
        ))}
      </Form>

      <Button style={{ marginTop: '10px' }} loading={submitting} onClick={() => submit() || update()} type="primary">
        {isNew ? 'Submit' : 'Update'}
      </Button>
    </CustomSpin>
  )
}

export default Form.create()(QuestionnaireSystemForm)
